<template>
  <a-form-model
    class="niche-light-form"
    :model="form"
    :layout="layout"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    ref="lightForm"
    label-align="left"
    :rules="rules"
  >
    <template v-if="step == 1">
      <template>
        <TabletInfo
          :value="tabletInfoValue"
          ref="tabletInfoRef"
          :entity="tabletInfoEntity"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          v-if="!modifyInfo"
        />
        <a-form-model-item
          label="供奉年数"
          prop="year_count"
          v-if="!modifyInfo"
        >
          <a-input-number
            v-model="form.year_count"
            :min="1"
            :max="10"
            :precision="0"
            placeholder="请输入供奉年数"
            style="width: 100%"
            disabled
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="所在地区" prop="location">
          <a-cascader
            :options="city"
            placeholder="请选择所在地区"
            v-model="form.location"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="详细地址" prop="address">
          <a-input
            v-model="form.address"
            placeholder="请输入详细地址"
            allow-clear
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="供奉人" prop="user_name">
          <a-input
            v-model="form.user_name"
            placeholder="请输入供奉人"
            allow-clear
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="mobile">
          <a-input v-model="form.mobile" placeholder="请输入联系方式"></a-input>
        </a-form-model-item>
      </template>
    </template>
    <template v-else>
      <a-form-model-item label="上传凭证" prop="bill">
        <form-upload v-model="form.bill"></form-upload>
      </a-form-model-item>
      <a-form-model-item label="处理人" prop="processor" v-if="!modifyInfo">
        <a-input v-model="form.processor" placeholder="请输入处理人"></a-input>
      </a-form-model-item>
    </template>
    <slot></slot>
  </a-form-model>
</template>

<script>
import moment from "moment";
import city from "../../../common/constant/city";
import TabletInfo from "./TabletInfo.vue";

export default {
  name: "NicheOrderForm",
  components: {
    TabletInfo,
  },
  props: {
    step: Number,
    modifyInfo: Boolean,
    info: Object,
    layout: {
      type: String,
      default: "horizontal",
    },
    labelCol: {
      type: Object,
      default: () => ({ span: 4 }),
    },
    wrapperCol: {
      type: Object,
      default: () => ({ span: 8 }),
    },
    tabletInfoValue: {
      type: Object,
    },
  },
  data() {
    return {
      tabletInfoEntity: {
        cat: 1,
        type: "02",
        relation: 1,
      },
      form: {
        year_count: 10,
      },
      rules: {
        year_count: [
          { required: true, message: "请输入供奉年数", trigger: "blur" },
        ],
        location: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        user_name: [
          { required: true, message: "请输入供奉人", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        bill: [{ required: true, message: "请上传凭证", trigger: "change" }],
        processor: [
          { required: true, message: "请输入处理人", trigger: "blur" },
        ],
      },
      city,
    };
  },
  watch: {
    info() {
      this.setForm();
    },
  },
  created() {
    this.setForm();
  },
  methods: {
    setForm() {
      const info = this.info;
      if (info) {
        this.form = {
          ...info,
        };
      } else {
        this.form = { year_count: 10 };
      }
    },
    validateTabletInfo() {
      return this.$refs.tabletInfoRef.checkForm();
    },
    submit() {
      return new Promise((resolve, reject) => {
        if (this.step == 1 && !this.modifyInfo) {
          this.validateTabletInfo()
            .then((info) => {
              // console.log("validateTabletInfo:", info, this.form);
              this.$refs.lightForm.validate((valid) => {
                if (valid) {
                  resolve({
                    ...this.form,
                    tablet_info: { ...this.tabletInfo, ...info },
                  });
                } else {
                  reject();
                }
              });
            })
            .catch(reject);
        } else {
          this.$refs.lightForm.validate((valid) => {
            if (valid) {
              resolve({ ...this.form });
            } else {
              reject();
            }
          });
        }
      });
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },
  },
};
</script>

<style lang="less">
.niche-light-form {
  padding: @padding-md;
}
</style>
